export default __webpack_public_path__ + "images/0402894add1cab96488e5049345b21d7.png";